function BannerProduct() {
    return (
        <div className="banner-product">
            <div className="row">
                <div className="col-md-6 col-xs-6">
                    <li>
                        <a href="">
                            <img
                                src="https://www.mensjournal.com/.image/t_share/MTk2MTM2NTU1NDAyMTEwMDk3/joyride1.jpg"
                                alt=""
                            />
                        </a>
                    </li>
                </div>
                <div className="col-md-6 col-xs-6">
                    <li>
                        <a href="">
                            <img
                                src="https://discover.zestmoney.in/wp-content/uploads/2021/01/shoe-banner.jpg"
                                alt=""
                            />
                        </a>
                    </li>
                </div>
            </div>
        </div>
    );
}

export default BannerProduct;
